import {navigate } from "gatsby";
import React, { useState } from "react";
import { Container } from "../../styles/UI";
import Input from "../../DesignSystem/Input";

import { useMediaQuery } from "react-responsive";

import Slider from "react-slick";


import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import msstartupLogo from "../../images/footer/ms-startup-footer.png";
import inovabraLogo from "../../images/footer/inovabra-footer.png";
import startupBadge from "../../images/footer/startup-badge.png";
import top1logo2024 from "../../images/footer/bigData.png";
import top10logo2022 from "../../images/footer/BigData_Branco.png";

//logos 2024
import top10logo2024 from "../../images/footer/LogoTop1024.png";
import gptw2024 from "../../images/footer/GPTW24.png";
import logoStartupsToWatch from "../../images/footer/100StartupsToWatch.png";
import logoCuboStartup from "../../images/footer/Selo_Cubo_Startup_2024_positivo_RGB.svg"

import facebookIcon from "../../images/footer/fb-icon.svg";
import linkedinIcon from "../../images/footer/li-icon.svg";
import instagramIcon from "../../images/footer/ig-icon.svg";

import mailIcon from "../../images/footer/mail.png";
import mappinIcon from "../../images/footer/map-pin.png";
import telIcon from "../../images/footer/whatsapp.png";
import telIcon1 from "../../images/footer/phone_in_talk.png";

import * as S from "./style";

export default function Footer(props) {
  const [email, setEmail] = useState("");

 const handleClick = () => {
    // modalRef1.current.openModal();
    if (props.taxdashs) {
      if (typeof window !== "undefined")
        // window.location.href = `https://azuremarketplace.microsoft.com/pt-br/marketplace/apps/taxcel.taxdashs?tab=overview`;
        window.location.href = `https://lp.taxcel.com.br/trial-taxdashs`;

      return;
    }

    navigate("/baixar-taxsheets#formulario", { state: { email } });
  };

  const handleChange = (e) => {
    const {
      target: { value },
    } = e;
    setEmail(value);
  };

  const logosReconhecimentos = [
    {id: "1", image: msstartupLogo},
    {id: "2", image: startupBadge},
    {id: "4", image: top10logo2024},
    {id: "5", image: top10logo2022},
    {id: "3", image: inovabraLogo},
    {id: "6", image: gptw2024},
    {id: "7", image: logoStartupsToWatch},
    {id: "8", image: logoCuboStartup},
    {id: "9", image: top1logo2024}  
  ];

  const isMobile = useMediaQuery({ query: "(max-width: 480px)" });
  const isTablet = useMediaQuery({ query: "(min-width: 768px) and (max-width: 834px)" });



  const settings = {
    slidesToShow: isMobile ? 2 : isTablet ? 3 : 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 900,
    arrows: false,
  };
  return (
    <S.Footer>
      <Container>
        <div>
          <S.Partners>
              <div  style={{
                width: "100%",
                height: "150px",
                alignItems: "center",
                overflow: "hidden",
                }}
              >
          <Slider {...settings}>
                {logosReconhecimentos && logosReconhecimentos.map((item) => (
                  <div key={item.id}>
                    <img
                      src={item.image}
                      alt="logos de clientes da Taxcel"
                      className="imageSlider"
                      style={{display: 'flex', width: 'auto', height: 'auto'}}
                    />
                  </div>
                ))}
          </Slider>
              </div>
          </S.Partners>
          <S.Taxcel>
            <img src="/logo.png" alt="Logo Taxcel" />
            <p>A gente simplifica. Você analisa.</p>
            <div>
              <a
                href="https://www.facebook.com/taxceladdins/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={facebookIcon} alt="ícone Facebook" />
              </a>
              <a
                href="https://www.instagram.com/taxcel_/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={instagramIcon} alt="ícone Instagram" />
              </a>
              <a
                href="https://www.linkedin.com/company/taxcel/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={linkedinIcon} alt="ícone Linkedin" />
              </a>
            </div>
          </S.Taxcel>
          <S.Links>
            <div>
              <h4>Produtos</h4>
              <a href="/taxdashs">TaxDashs</a>
              <a href="/taxsheets">TaxSheets</a>
              <a href="/planos">Planos</a>
              <a href="https://taxceladdins.zendesk.com/hc/pt-br">
                Portal de ajuda
              </a>
              <a href="https://taxceladdins.zendesk.com/hc/pt-br/sections/115001817087-Perguntas-Frequentes">
                FAQ
              </a>
              <a href="https://taxceladdins.zendesk.com/hc/pt-br/sections/115001816827--TaxSheets-Editor-SPED-V%C3%ADdeos-Tutoriais">
                Tutoriais
              </a>
              <a href="/termos-de-uso">Termos de uso</a>
               <a href="https://lp.taxcel.com.br/future-of-tax-summit-by-taxcel">Future of Tax Taxcel</a>
              {/* <Link to="/agro">Agro</Link> */}
            </div>
            <div>
              <h4>Institucional</h4>
              <a href="/sobre">Quem somos</a>
              <a href="/contato">Fale conosco</a>
              <a href="https://blog.taxceladdins.com.br/">Blog</a>

              <a href="https://forms.office.com/Pages/ResponsePage.aspx?id=Q11Ffv4l2UuxcJR9hsUcUAZQ644QVKRAtqM3YQre8UtUNENZTDM5RFpDTFFPVjRCN1FPMDRPWkFHWiQlQCN0PWcu">
                Trabalhe conosco
              </a>
              <a href="/politica-de-privacidade">Política de Privacidade</a>
              <a href="/politica-de-seguranca-da-informacao">
                Política de Segurança <br /> da Informação
              </a>
              <a href="https://forms.office.com/Pages/ResponsePage.aspx?id=Q11Ffv4l2UuxcJR9hsUcUGZ4KBrc-D5LoJFsewsDfhpUMTZLVkpTWFhCMVE1Vk9VTjYzQVdaUDcwVC4u">
                Formulário de LGPD
              </a>
              <a href="https://forms.office.com/r/VNgFp68WEK">
                Canal de denúncias
              </a>
              <a href="https://app.drata.com/trust/a16d79c1-52a8-45d7-a51a-e7b0c9fe2734">
                Central de Segurança
              </a>
            </div>
            <div>
              <h4>Parceiros</h4>
              <a href="https://sites.google.com/view/parceiros-taxcel/home">
                Portal
              </a>{" "}
              {/* <a href="https://conteudo.taxcel.com.br/indique-ganhe">
                Indique e ganhe
              </a> */}
            </div>
            <div className="contato">
              <h4>Contato</h4>
              <div className="icone-texto">
                <img src={mailIcon} alt="ícone de email" />
                <div>
                  <a href="mailto@contato@taxcel.com.br">
                    contato@taxcel.com.br
                  </a>
                  <a href="mailto@suporte@taxcel.com.br">
                    suporte@taxcel.com.br
                  </a>
                </div>
              </div>
              <div className="icone-texto">
                <img src={telIcon1} alt="ícone do whatsapp" />
                <p>
                  <a
                    href="https://api.whatsapp.com/send/?phone=551150267387&text&app_absent=0"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    (11) 5039-4214
                  </a>
                </p>
              </div>
              <div className="icone-texto">
                <img src={mappinIcon} alt="ícone de localização" />
                <div>
                  <p>R. da Consolação, 2302</p>
                  <p>Consolação, São Paulo</p>
                </div>
              </div>
              <p className="atendimento">
                Atendimento de segunda <br />a sexta das 9h às 17h
              </p>
            </div>
            <div>
              <h4>Teste grátis!</h4>
              <Input
                value={email}
                onChange={handleChange}
                short
                negative
                placeholder="Seu email"
              >
                <a
      href="/baixar-taxsheets#formulario"
      style={{
        padding: "6px",
        fontWeight: 600,
        fontSize: "inherit",
        lineHeight: 1.625,
        display: "flex",
        alignItems: "center",
        borderRadius: "0px 12px",
        justifyContent: "center",
        marginBottom: "0px",
        width: "123px",
        color: "rgb(252, 252, 252)",
        backgroundColor: "rgb(0, 69, 142)",
        textDecoration: "none",
        position: "relative", 
        cursor: "pointer"
      }}
    >
        Testar Trial
        </a>
              </Input>
            </div>
          </S.Links>
        </div>
      </Container>
      <S.Copyright>
        <Container>
          © {new Date().getFullYear()} Taxcel. Todos os direitos reservados.
        </Container>
      </S.Copyright>
    </S.Footer>
  );
}